import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    description: 'createOrderModal.modalTitle',
    defaultMessage: 'New Manual Order',
    id: 'dwPj6j',
  },
  save: {
    description: 'createOrderModal.save',
    defaultMessage: 'Save Order',
    id: '3J+1FA',
  },
  saveAndView: {
    description: 'createOrderModal.saveOrder',
    defaultMessage: 'Save and Ship!',
    id: 'VbRRRe',
  },
  saveAndCreateAnother: {
    description: 'createOrderModal.saveAndCreateAnother',
    defaultMessage: 'Save and Create Another',
    id: 'FWA9fh',
  },
  recipientName: {
    description: 'createOrderModal.recipientName',
    defaultMessage: 'Recipient Name',
    id: 'q0UFKL',
  },
  shipToTitle: {
    description: 'createOrderModal.shipToTitle',
    defaultMessage: 'Ship To',
    id: 'LJ9iVF',
  },
  soldToTitle: {
    description: 'createOrderModal.soldToTitle',
    defaultMessage: 'Sold To',
    id: '8G26mM',
  },
  orderItems: {
    description: 'createOrderModal.orderItems',
    defaultMessage: 'Order Items',
    id: 'De7tYJ',
  },
  pasteEntireAddress: {
    description: 'createOrderModal.pasteEntireAddress',
    defaultMessage: 'Paste Entire US Address',
    id: 'fqUSp3',
  },
  thisIsAGift: {
    description: 'createOrderModal.thisIsAGift',
    defaultMessage: 'This is a gift',
    id: 'kEtVTg',
  },
  recipientAddress: {
    description: 'createOrderModal.recipientAddress',
    defaultMessage: 'Recipient Address',
    id: 'EMDTiZ',
  },
  shipToPhone: {
    description: 'createOrderModal.shipToPhone',
    defaultMessage: 'Phone Number',
    id: 'd18iGk',
  },
  title: {
    description: 'createOrderModal.title',
    defaultMessage: 'New Order',
    id: 'oHYdFV',
  },
  recipientTitle: {
    description: 'createOrderModal.recipientTitle',
    defaultMessage: 'Recipient Information',
    id: 'drZpjy',
  },
  orderSummaryTitle: {
    description: 'createOrderModal.orderSummaryTitle',
    defaultMessage: 'Order Summary Information',
    id: '2d+ySW',
  },
  orderItemsTitle: {
    description: 'createOrderModal.orderItemsTitle',
    defaultMessage: 'Order Line Items',
    id: 'EmwVp1',
  },
  autogenerateOrderNumber: {
    description: 'createOrderModal.autogenerateOrderNumber',
    defaultMessage: 'Autogenerate Order #',
    id: 'y0pSbj',
  },
  autoGeneratedOrderNumberInputMessage: {
    description: 'createOrderModal.autoGeneratedOrderNumberInputMessage',
    defaultMessage: 'Order # will be autogenerated',
    id: '6EUfl4',
  },
  orderNumber: {
    description: 'createOrderModal.orderNumber',
    defaultMessage: 'Order #',
    id: 'UKFdat',
  },
  store: {
    description: 'createOrderModal.store',
    defaultMessage: 'Store',
    id: 'OYQHeN',
  },
  orderDate: {
    description: 'createOrderModal.orderDate',
    defaultMessage: 'Order Date',
    id: 'Zvpl2o',
  },
  paidDate: {
    description: 'createOrderModal.paidDate',
    defaultMessage: 'Paid Date',
    id: 'V5pcVX',
  },
  shippingPaid: {
    description: 'createOrderModal.shippingPaid',
    defaultMessage: 'Shipping Paid',
    id: 'b7DfAh',
  },
  taxPaid: {
    description: 'createOrderModal.taxPaid',
    defaultMessage: 'Tax Paid',
    id: 'RhZCAE',
  },
  totalPaid: {
    description: 'createOrderModal.totalPaid',
    defaultMessage: 'Total Paid',
    id: 'jHwoym',
  },
  totalOrder: {
    description: 'createOrderModal.totalOrder',
    defaultMessage: 'Total Order',
    id: 'AWjl2u',
  },
  productTotal: {
    description: 'createOrderModal.productTotal',
    defaultMessage: 'Product Total',
    id: 'tG1HpY',
  },
  addLineItem: {
    description: 'createOrderModal.addLineItem',
    defaultMessage: '+ Add a Line Item',
    id: '4kLnqJ',
  },
  itemHeaderSku: {
    description: 'createOrderModal.itemHeaderSku',
    defaultMessage: 'SKU',
    id: 'WhcLrh',
  },
  itemHeaderName: {
    description: 'createOrderModal.itemHeaderName',
    defaultMessage: 'Name',
    id: 'rS6yri',
  },
  itemHeaderQuantity: {
    description: 'createOrderModal.itemHeaderQuantity',
    defaultMessage: 'Quantity',
    id: 'Dbft5P',
  },
  itemHeaderPrice: {
    description: 'createOrderModal.itemHeaderPrice',
    defaultMessage: 'Price',
    id: 'TYxyZJ',
  },
  parseFailTitle: {
    description: 'parseError.title',
    defaultMessage: 'Error Parsing Address',
    id: 'nkK0B1',
  },
  parseFailMessage: {
    description: 'parseError.message',
    defaultMessage: 'There was a problem parsing the pasted address. Please try again later.',
    id: 'yhiZzo',
  },
  newOrderConfirmCancelBody: {
    description: 'Body text to exit New Order creation',
    defaultMessage: 'If you close this window, all unsaved data will be lost. Are you sure you want to exit?',
    id: 'gdXw/s',
  },
  newOrderConfirmCancelButton: {
    description: 'Button text to exit New Order creation',
    defaultMessage: 'OK',
    id: '5YMkY5',
  },
  newOrderConfirmCancelHeader: {
    description: 'Header text to exit New Order creation',
    defaultMessage: 'Confirmation',
    id: 'RIzxQq',
  },
});

export default messages;
